module.exports = __webpack_public_path__ + "static/media/Products.2e2163af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NavIcons/Products.png
// module id = 591
// module chunks = 0